<template>
  <custom-popup v-model="computedValue" :cons="{title: 'افزدن حساب'}" hide-confirm max-width="600">
    <v-card flat>
      <v-card-title class="red--text">
        ورود کلیه اطلاعات الزامی است.
      </v-card-title>

      <v-row class="pa-2" justify="center" no-gutters>
        <v-col class="pa-2" cols="12" lg="6" md="9" sm="10">
          <v-text-field v-model="obj.ownerName" :rules="[rules.persian]" class="rounded-lg"
                        clear-icon="mdi-close-circle-outline" clearable dense label="نام صاحب حساب" outlined/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="6" md="9" sm="10">
          <v-text-field v-model="obj.ownerLastName" :rules="[rules.persian]" class="rounded-lg"
                        clear-icon="mdi-close-circle-outline" clearable dense label="نام خانوادگی" outlined/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="6" md="9" sm="10">
          <v-text-field v-model="obj.bankName" :rules="[rules.persian]" class="rounded-lg icon-wrapper"
                        clear-icon="mdi-close-circle-outline" clearable dense label="نام بانک" outlined>
            <template v-slot:append>
              <v-img :src="banksPrefix?.icon" contain width="32"/>
            </template>
          </v-text-field>
        </v-col>

        <v-col class="pa-2" cols="12" lg="6" md="9" sm="10">
          <v-text-field v-model="obj.accountNumber" class="rounded-lg" clear-icon="mdi-close-circle-outline" clearable
                        dense label="شماره حساب" outlined type="number"/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="8" md="9" sm="10">
          <v-text-field v-model="obj.cardNumber" :rules="[rules.cardNumber]" class="rounded-lg"
                        clear-icon="mdi-close-circle-outline" clearable counter="16" dense label="شماره کارت" outlined
                        type="number"/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="8" md="9" sm="10">
          <v-text-field v-model="obj.sheba" :rules="[rules.sheba]" class="rounded-lg" counter="24" dense
                        label="شماره شبا" outlined suffix="IR" type="number"/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="8" md="9" sm="10">
          <v-divider/>
          <v-btn :disabled="canAddAcc" :loading="addLoading" block color="success" depressed
                 @click="addToAccountList">
            <v-icon left>mdi-plus</v-icon>
            افزودن حساب
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </custom-popup>
</template>

<script>
export default {
  name: "addBankAccount",

  props: {
    value: Boolean,
    selected: [Number, null]
  },

  data() {
    return {
      addLoading: false,
      banksInfo: [],
      obj: {
        bankName: '',
        ownerName: '',
        ownerLastName: '',
        accountNumber: '',
        cardNumber: '',
        sheba: '',
      },
      rules: {
        persian: v => (this.justPersian(v)) || 'فقط مجاز به ورود حروف فارسی!',
        cardNumber: v => v.length === 16 || 'تعداد ارقام شماره کارت باید ۱۶ عدد باشد!',
        sheba: v => v.length === 24 || 'تعداد ارقام شماره شبا باید ۲۴ عدد باشد!'
      }
    }
  },

  mounted() {
    this.banksInfo = [
      {
        "text": "اقتصاد نوین",
        "value": "eghtesad novin",
        "prefix": ["627412"],
        "icon": require('../../../../assets/img/banks/eghtesad-novin.webp')
      },
      {
        "text": "انصار",
        "value": "ansar",
        "prefix": ["627381"],
        "icon": require('../../../../assets/img/banks/ansar.webp')
      },
      {
        "text": "ایران زمین",
        "value": "iran-zamin",
        "prefix": ["505785"],
        "icon": require('../../../../assets/img/banks/iran-zamin.webp')
      },
      {
        "text": "پارسیان",
        "value": "parsian",
        "prefix": ["622106", "639194", "627884"],
        "icon": require('../../../../assets/img/banks/parsian.webp')
      },
      {
        "text": "پاسارگاد",
        "value": "pasargad",
        "prefix": ["639347", "5022-29"],
        "icon": require('../../../../assets/img/banks/pasargad.webp')
      },
      {
        "text": "تات",
        "value": "tat",
        "prefix": ["636214"],
        "icon": require('../../../../assets/img/banks/tat.webp')
      },
      {
        "text": "تجارت",
        "value": "tejarat",
        "prefix": ["627353"],
        "icon": require('../../../../assets/img/banks/tejarat.webp')
      },
      {
        "text": "توسعه تعاون",
        "value": "tosee-taavon",
        "prefix": ["502908"],
        "icon": require('../../../../assets/img/banks/taavon.webp')
      },
      {
        "text": "توسعه صادرات ایران",
        "value": "tosee-saderat",
        "prefix": ["627648", "207177"],
        "icon": ''
      },
      {
        "text": "حکمت ایرانیان",
        "value": "hekmat-iraniyan",
        "prefix": ["636949"],
        "icon": require('../../../../assets/img/banks/hekmat.webp')
      },
      {
        "text": "دی",
        "value": "dey",
        "prefix": ["502938"],
        "icon": require('../../../../assets/img/banks/dey.webp')
      },
      {
        "text": "رفاه کارگران",
        "value": "refah-kargar",
        "prefix": ["589463"],
        "icon": require('../../../../assets/img/banks/refah.webp')
      },
      {
        "text": "سامان",
        "value": "saman",
        "prefix": ["621986"],
        "icon": require('../../../../assets/img/banks/saman.webp')
      },
      {
        "text": "سپه",
        "value": "sepah",
        "prefix": ["589210"],
        "icon": require('../../../../assets/img/banks/sepah.webp')
      },
      {
        "text": "سرمایه",
        "value": "sarmayeh",
        "prefix": ["639607"],
        "icon": require('../../../../assets/img/banks/sarmayeh.webp')
      },
      {
        "text": "سینا",
        "value": "sina",
        "prefix": ["639346"],
        "icon": require('../../../../assets/img/banks/sina.webp')
      },
      {
        "text": "شهر",
        "value": "shahr",
        "prefix": ["502806"],
        "icon": require('../../../../assets/img/banks/shahr.webp')
      },
      {
        "text": "صادرات ایران",
        "value": "saderat-iran",
        "prefix": ["603769"],
        "icon": require('../../../../assets/img/banks/saderat.webp')
      },
      {
        "text": "صنعت و معدن",
        "value": "sanat-madan",
        "prefix": ["627961"],
        "icon": require('../../../../assets/img/banks/sanat-madan.webp')
      },
      {
        "text": "قرض الحسنه مهر ایران",
        "value": "ghorze-alhasane-mehr-iran",
        "prefix": ["606373"],
        "icon": require('../../../../assets/img/banks/mehre-iran.webp')
      },
      {
        "text": "قوامین",
        "value": "ghavamin",
        "prefix": ["639599"],
        "icon": require('../../../../assets/img/banks/ghavamin.webp')
      },
      {
        "text": "کارآفرین",
        "value": "karaafarin",
        "prefix": ["627488", "502910"],
        "icon": require('../../../../assets/img/banks/karafarin.webp')
      },
      {
        "text": "کشاورزی",
        "value": "keshavarzi",
        "prefix": ["603770", "639217"],
        "icon": require('../../../../assets/img/banks/keshavarzi.webp')
      },
      {
        "text": "گردشگری",
        "value": "gardeshgari",
        "prefix": ["505416"],
        "icon": require('../../../../assets/img/banks/gardeshgari.webp')
      },
      {
        "text": "مرکزی",
        "value": "markazi",
        "prefix": ["636795"],
        "icon": require('../../../../assets/img/banks/markazi.webp')
      },
      {
        "text": "مسکن",
        "value": "maskan",
        "prefix": ["628023"],
        "icon": require('../../../../assets/img/banks/maskan.webp')
      },
      {
        "text": "ملت",
        "value": "melat",
        "prefix": ["610433", "991975"],
        "icon": require('../../../../assets/img/banks/mellat.webp')
      },
      {
        "text": "ملی",
        "value": "melli-iran",
        "prefix": ["603799"],
        "icon": require('../../../../assets/img/banks/melli.webp')
      },
      {
        "text": "مهر اقتصاد",
        "value": "mehr-eghtesad",
        "prefix": ["639370"],
        "icon": require('../../../../assets/img/banks/mehre-eghtesad.webp')
      },
      {
        "text": "پست بانک ایران",
        "value": "post-bank-iran",
        "prefix": ["627760"],
        "icon": ""
      },
      {
        "text": "موسسه اعتباری توسعه",
        "value": "etebari-tosee",
        "prefix": ["628157"],
        "icon": ""
      },
      {
        "text": "موسسه اعتباری کوثر",
        "value": "etebari-kosar",
        "prefix": ["505801"],
        "icon": require('../../../../assets/img/banks/kosar.webp')
      }
    ]
  },

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    canAddAcc() {
      let arr = Object.values(this.obj)
      return arr.filter(item => !!item).length !== arr.length
          || typeof this.rules.persian(this.obj.bankName) !== 'boolean'
          || typeof this.rules.persian(this.obj.ownerName) !== 'boolean'
          || typeof this.rules.persian(this.obj.ownerLastName) !== 'boolean'
          || typeof this.rules.cardNumber(this.obj.cardNumber) !== 'boolean'
          || typeof this.rules.sheba(this.obj.sheba) !== 'boolean'
    },
    banksPrefix() {
      let arr = this.banksInfo,
          str = this.obj.cardNumber
      return arr.find(item =>
          item.prefix.includes(str?.substring(0, 6)))
    }
  },

  methods: {
    addToAccountList() {
      this.addLoading = true

      this.$DashboardAxios.post('/api/admin/account', this.obj)
          .then(({data}) => {
            this.$emit('update:selected', data.data.id)
            this.addAccount = false
            this.$emit('fetch')
          })
          .catch(({response}) => console.error('error in add account: ', response))
          .finally(() => this.addLoading = false);
    },
    justPersian(str) {
      var p = /^[\u0620-\u065F\u0671-\u06D5\s]+$/;
      return p.test(str)
    }
  }
}
</script>

<style scoped>
.icon-wrapper >>> .v-input__append-inner {
  align-self: center;
  margin: 0 !important;
}
</style>